export default __webpack_public_path__ + "static/media/gallery_09.94585984.jpg";